import React, { ComponentType, useCallback, useEffect, useMemo, useState } from 'react';
import { Chip, styled } from '@mui/material';
import { isEmpty, isUndefined } from 'lodash';
import { formatNumbers } from 'utilities';
import { WithChipProps } from './WithChip.props';
import { classes, Root } from './WithChip.styles';


// eslint-disable-next-line react/display-name
const withChip = (WrappedComponent: ComponentType<any>) =>
  React.memo((props: WithChipProps) => {
    const [value, setValue] = useState('');

    const calcValue = useCallback(() => {
      if (
        (!isUndefined(props.cell.chip?.value) || props.cell.chip?.value)
        && props.cell.chip?.gridType
        && (props.cell.chip?.gridType === 'number' || props.cell.chip?.gridType === 'percentage')
        // eslint-disable-next-line no-restricted-globals
        && !isNaN(props.cell.chip?.value)
      ) {
        return formatNumbers(props.cell.chip as any);
      }
      return props.cell.chip?.value;
    }, [props.cell]);

    const getValue = useCallback(() => {
      setValue(calcValue());
    }, [calcValue]);

    useEffect(() => {
      if (!isEmpty(props.cell.chip)) {
        getValue();
      }
    }, [getValue, props.cell]);

    const CellContent = useMemo(() => {
      if (props.cell.valueViewer) {
        return <WrappedComponent {...props} />;
      }

      return props.cell.component
        ? React.cloneElement(props.cell.component, { cell: props.cell }, null)
        : formatNumbers(props.cell as any);
    }, [props]);

    if (isEmpty(props.cell.chip)) {
      return <WrappedComponent {...props} />;
    }

    return (
      <Root className={`dialog ${classes.root}`}>
        <div className="dialog__value">
          <span className="value-viewer">{CellContent}</span>
        </div>
        <div className={classes.chipContainer}>
          <Chip label={value} variant="outlined" className={classes.chip} />
        </div>
      </Root>
    );
  });

export default withChip;
